"use strict";
var base = require("../product/base");

/**
 * @function
 * @description
 */
const initCartSliderEvents = () => {

    $(document).on("click", ".js-swatch-update", e => {
        var $this = $(e.currentTarget);
        var $productTileImageElement = $($this.closest(".product-tile").find(".tile-image"));
        var swatchImageSrc = $this.data("js-product-image-source");

        $productTileImageElement.attr("srcset", swatchImageSrc);
    });

    $(document).on("click", "[data-toggle='tooltip']", e => {
        var $this = $(e.currentTarget);

        $this.tooltip({
            container: $this.parent(),
            placement: "left"
        });
    });

    $(document).on("click", ".c-product-slider__cart-slider .slick-arrow", () => {
        base.preselectAttrs();
    });

    $(document).on("touchend", ".c-product-slider__cart-slider .slick-slide", () => {
        base.preselectAttrs();
    });

    $("body").one("cartProductSliderLoaded", () =>{
        $(".c-einstein-slider.slick-slider").on("init", () => {
            base.preselectAttrs();
        });
    });
};

module.exports = initCartSliderEvents;
